import * as line from './chart-line';
import * as area from './chart-area';
import * as bar from './chart-bar';
import * as pie from './chart-pie';

/**
 * Updates options for specific chart types.
 */
export function preRender(data, options) {
  switch (options.type) {
    case 'line':
      return line.preRender(data, options);
    case 'area':
      return area.preRender(data, options);
    case 'pie':
      return pie.preRender(data, options);
    case 'bar':
    case 'column':
      return bar.preRender(data, options);
  }
  return data;
}


export function postRender(highchart, options) {
  switch (options.type) {
    case 'line':
      line.postRender(highchart, options);
      break;
    case 'area':
      area.postRender(highchart, options);
      break;
    case 'pie':
      pie.postRender(highchart, options);
      break;
    case 'bar':
    case 'column':
      bar.postRender(highchart, options);
      break;
  }
}


export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    switch (options.type) {
      case 'line':
        return line.renderInvalidated(rendered, options, invalidated);
      case 'area':
        return area.renderInvalidated(rendered, options, invalidated);
      case 'pie':
        return pie.renderInvalidated(rendered, options, invalidated);
      case 'bar':
      case 'column':
        return bar.renderInvalidated(rendered, options, invalidated);
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/chart/inner/chart.js